import { render } from "./UITimeInput.vue?vue&type=template&id=320aa99b"
import script from "./UITimeInput.vue?vue&type=script&lang=ts"
export * from "./UITimeInput.vue?vue&type=script&lang=ts"
script.render = render

export default script